import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

const LANGUAGES = [
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'kz', name: 'Қазақша', flag: '🇰🇿' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = i18n.language || 'ru';
  const currentLangData = LANGUAGES.find(l => l.code === currentLang) || LANGUAGES[0];

  const changeLanguage = (langCode) => {
    // Get current path without language prefix
    const pathParts = location.pathname.split('/');
    const currentPathLang = pathParts[1];
    
    let newPath;
    if (['ru', 'kz', 'en'].includes(currentPathLang)) {
      // Replace existing language prefix
      pathParts[1] = langCode;
      newPath = pathParts.join('/');
    } else {
      // Add language prefix
      newPath = `/${langCode}${location.pathname}`;
    }
    
    // Handle root path
    if (newPath === `/${langCode}/` || newPath === `/${langCode}`) {
      newPath = `/${langCode}`;
    }
    
    i18n.changeLanguage(langCode);
    navigate(newPath + location.search);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1 px-2">
          <Globe className="w-4 h-4" />
          <span className="hidden sm:inline">{currentLangData.flag}</span>
          <span className="uppercase text-xs font-medium">{currentLang}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={currentLang === lang.code ? 'bg-gray-100' : ''}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageSwitcher;
